export class StoreValidationError extends Error {}

export const fail = (message: string): never => {
  throw new StoreValidationError(message);
};

export const oneOf = (
  value: unknown,
  allowed: readonly string[],
  what: string,
): void => {
  if (typeof value !== "string" || !allowed.includes(value))
    fail(`${what} must be one of ${allowed.join(", ")}: got ${String(value)}`);
};

export const bool = (value: unknown, what: string): void => {
  if (typeof value !== "boolean") fail(`${what} must be a boolean`);
};

export const nonEmptyString = (value: unknown, what: string): void => {
  if (typeof value !== "string" || value.length === 0)
    fail(`${what} must be a non-empty string`);
};

export const IPV4 = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
export const ISO_8601_PREFIX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
export const KEY_CODE = /^[A-Za-z][A-Za-z0-9]*$/;

export const stringList = (value: unknown, what: string): void => {
  if (
    !Array.isArray(value) ||
    value.some((item) => typeof item !== "string" || item.length === 0)
  )
    fail(`${what} must be a list of non-empty strings`);
};
